import React from 'react';

interface CheckListIconProps {
  wrapperClassNames?: string;
  pathClassNames?: string;
}

const CheckListIcon = ({
  wrapperClassNames,
  pathClassNames,
}: CheckListIconProps) => (
  <svg
    className={wrapperClassNames}
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="72" height="72" rx="36" fill="#F3F4F6" />
    <mask
      id="mask0_5184_9446"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="16"
      y="16"
      width="40"
      height="40"
    >
      <rect x="16" y="16" width="40" height="40" fill="#E5E7EB" />
    </mask>
    <g mask="url(#mask0_5184_9446)">
      <path
        className={pathClassNames}
        d="M39.3332 30.999C38.8609 30.999 38.4654 30.839 38.1465 30.519C37.8265 30.2001 37.6665 29.8046 37.6665 29.3323C37.6665 28.8601 37.8265 28.464 38.1465 28.144C38.4654 27.8251 38.8609 27.6657 39.3332 27.6657H50.9998C51.4721 27.6657 51.8676 27.8251 52.1865 28.144C52.5065 28.464 52.6665 28.8601 52.6665 29.3323C52.6665 29.8046 52.5065 30.2001 52.1865 30.519C51.8676 30.839 51.4721 30.999 50.9998 30.999H39.3332ZM39.3332 44.3323C38.8609 44.3323 38.4654 44.1723 38.1465 43.8523C37.8265 43.5334 37.6665 43.1379 37.6665 42.6657C37.6665 42.1934 37.8265 41.7973 38.1465 41.4773C38.4654 41.1584 38.8609 40.999 39.3332 40.999H50.9998C51.4721 40.999 51.8676 41.1584 52.1865 41.4773C52.5065 41.7973 52.6665 42.1934 52.6665 42.6657C52.6665 43.1379 52.5065 43.5334 52.1865 43.8523C51.8676 44.1723 51.4721 44.3323 50.9998 44.3323H39.3332ZM24.0832 33.1657L20.4998 29.5823C20.1943 29.2768 20.0415 28.8879 20.0415 28.4157C20.0415 27.9434 20.1943 27.5546 20.4998 27.249C20.8054 26.9434 21.1943 26.7907 21.6665 26.7907C22.1387 26.7907 22.5276 26.9434 22.8332 27.249L25.2082 29.624L31.1248 23.7073C31.4582 23.374 31.8471 23.214 32.2915 23.2273C32.7359 23.2418 33.1248 23.4157 33.4582 23.749C33.7637 24.0823 33.9165 24.4712 33.9165 24.9157C33.9165 25.3601 33.7637 25.749 33.4582 26.0823L26.4165 33.1657C26.0832 33.499 25.6943 33.6657 25.2498 33.6657C24.8054 33.6657 24.4165 33.499 24.0832 33.1657ZM24.0832 46.499L20.4998 42.9157C20.1943 42.6101 20.0415 42.2212 20.0415 41.749C20.0415 41.2768 20.1943 40.8879 20.4998 40.5823C20.8054 40.2768 21.1943 40.124 21.6665 40.124C22.1387 40.124 22.5276 40.2768 22.8332 40.5823L25.2082 42.9573L31.1248 37.0407C31.4582 36.7073 31.8471 36.5473 32.2915 36.5607C32.7359 36.5751 33.1248 36.749 33.4582 37.0823C33.7637 37.4157 33.9165 37.8046 33.9165 38.249C33.9165 38.6934 33.7637 39.0823 33.4582 39.4157L26.4165 46.499C26.0832 46.8323 25.6943 46.999 25.2498 46.999C24.8054 46.999 24.4165 46.8323 24.0832 46.499Z"
        fill="#655DFD"
      />
    </g>
  </svg>
);

export default CheckListIcon;
